import type { RoomStatusItem } from "../types/dashboard.types";

interface RoomsStatusDonutProps {
	items: RoomStatusItem[];
	centerValue: string;
	centerLabel: string;
	onItemClick?: (label: string) => void;
	onCenterClick?: () => void;
}

export function RoomsStatusDonut({
	items,
	centerLabel,
	centerValue,
	onItemClick,
	onCenterClick,
}: RoomsStatusDonutProps) {
	const circumference = 2 * Math.PI * 58;
	const total = items.reduce((sum, item) => sum + item.value, 0);
	let offset = 0;

	return (
		<div className="crm-donut-wrap">
			<div className="crm-donut">
				<svg aria-hidden="true" viewBox="0 0 140 140">
					<circle cx="70" cy="70" r="58" />
					{items.map((item) => {
						const dash = (item.value / total) * circumference;
						const strokeDashoffset = -offset;
						offset += dash;

						return (
							<circle
								cx="70"
								cy="70"
								key={item.label}
								r="58"
								style={{
									stroke: item.color,
									strokeDasharray: `${dash} ${circumference}`,
									strokeDashoffset,
									cursor: onItemClick ? "pointer" : "default",
								}}
								onClick={() => onItemClick?.(item.label)}
							/>
						);
					})}
				</svg>
				<div
					style={{
						pointerEvents: "none",
						position: "absolute",
						inset: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
					}}
				>
					<div
						onClick={onCenterClick}
						style={{
							cursor: onCenterClick ? "pointer" : "default",
							pointerEvents: "auto",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<strong>{centerValue}</strong>
						<span>{centerLabel}</span>
					</div>
				</div>
			</div>
			<div className="crm-donut-legend">
				{items.map((item) => (
					<div
						key={item.label}
						onClick={() => onItemClick?.(item.label)}
						style={{ cursor: onItemClick ? "pointer" : "default" }}
					>
						<span style={{ background: item.color }} />
						<p>{item.label}</p>
						<b>{item.value}</b>
					</div>
				))}
			</div>
		</div>
	);
}
